<template>
    <div v-if="isActive" class="table-overlay" @click.self="isActive = false">
        <div class="container-table">
            <h4 v-html="params.title || 'Undefined'"></h4>
            <p v-html="params.subTitle || 'Undefined'"></p>
            <div class="nav" v-if="tables.length > 1">
                <div 
                    v-for="(table, index) in tables" 
                    :key="item" 
                    class="icon-l" 
                    :class="{'btn-primary' : index == tableIndexSelected}"
                    @click="tableIndexSelected = index"
                >
                    {{ table.label || table.name }}
                </div>
            </div>
            <div class="container-custom-table" :style="{ height: (maxRows+1)*45 + 'px' }">
                <div  class="custom-table">
                    <table>
                        <thead>
                            <tr>
                                <th v-for="column in tables[tableIndexSelected].columns" :key="column.key">
                                    {{ column.label }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rowIndex) in tables[tableIndexSelected].data" :key="rowIndex">
                                <td 
                                    v-for="column in tables[tableIndexSelected].columns" :key="column.key"
                                    :style="{ 
                                        color: column.dataColor ? column.dataColor : '#696D76',
                                        fontWeight: column.dataFontWeight ? column.dataFontWeight : '500'

                                    }"
                                >
                                    {{ row[column.key] ? row[column.key] : '\u00A0\u00A0-' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import store from './../../../store';
import Checkbox from '../utils/checkbox.vue'
import { EventBus } from '@/event-bus';

const paramsDefault = {
    title: 'Table',
    subTitle: ''
}

export default {
    components: {
        Checkbox,
    },

    data() {
        return {
            isActive: false,
            params: paramsDefault,

            tableIndexSelected: 0,
            tables: [],
            maxRows: null,
        }
    },

    mounted(){
        EventBus.$on('showTable', this.showTable);
    },


    methods: {
        // cb(users[], isCancled)
        showTable(params) {
            this.isActive = true
            this.tableIndexSelected = 0
            this.params = {...paramsDefault,...params}
            this.tables = params.tables || [params.table] 
            this.maxRows = this.tables.reduce((max, table) => Math.max(max, table.data.length), 0);
        },
        validSelection() {
           
        },
        cancel() {
           
        },

      
      

    


    },

    computed: {
   
    },

    beforeDestroy() {
        EventBus.$off('showTable', this.showTable);
    },


}
</script>

<style lang="scss" scoped>

</style>